import { render, staticRenderFns } from "./SuperAdminSetNewPassword.vue?vue&type=template&id=4330fb98&scoped=true&"
import script from "./SuperAdminSetNewPassword.vue?vue&type=script&lang=js&"
export * from "./SuperAdminSetNewPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330fb98",
  null
  
)

export default component.exports